// extracted by mini-css-extract-plugin
export var advantage = "style-module--advantage--6b941";
export var advantage__bigText = "style-module--advantage__big-text--6eedc";
export var advantage__description = "style-module--advantage__description--2ca20";
export var advantage__item = "style-module--advantage__item--f6377";
export var advantage__list = "style-module--advantage__list--8fec8";